require('../../../modules/es.string.sub');
var entryVirtual = require('../../../internals/entry-virtual');

module.exports = entryVirtual('String').sub;
